import { FileProcessingConfig } from "./fileProcessing";

export const fileProcessingConfigs: FileProcessingConfig[] = [
  {
    mimeType: ["application/pdf"],
    questions: [
      {
        key: "hasHandwriting",
        question: "Does your PDF contain handwritten content?",
        note: 'Selecting "Yes" will take longer to process',
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
      {
        key: "processImages",
        question:
          "Should the AI analyze visual content (images, charts, etc.) in your PDF?",
        note: 'Selecting "Yes" will take longer to process',
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
    ],
  },
  // {
  //   mimeType: ["image/jpeg", "image/png", "image/gif"],
  //   questions: [
  //     {
  //       key: "hasHandwriting",
  //       question: "Does your image contain handwritten text?",
  //       note: 'Selecting "Yes" will take longer to process',
  //       options: [
  //         { value: true, label: "Yes" },
  //         { value: false, label: "No" },
  //       ],
  //     },
  //   ],
  // },
];
